export default __webpack_public_path__ + "static/media/parking-pmr.1e50f7b6.svg";